import React from 'react';
import { Container } from 'react-bootstrap';
import { faExternalLinkAlt, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import certificates from '../../data/certificates';
import { useLanguage } from '../../context/LanguageContext';
import './style.scss';

const IMAGE_URL_PATTERN = /\.(png|jpe?g|webp|gif)(\?.*)?$/i;

const getPreviewUrl = (entry) => {
  if (entry.previewUrl) {
    return entry.previewUrl;
  }
  if (entry.credentialUrl && IMAGE_URL_PATTERN.test(entry.credentialUrl)) {
    return entry.credentialUrl;
  }
  return null;
};

const isPdfUrl = (url) => /\.pdf(\?.*)?$/i.test(url);

const SectionCertificates = () => {
  const { t, lang } = useLanguage();

  if (certificates.length === 0) {
    return null;
  }

  return (
    <section id="certificates" className="section-certificates">
      <Container className="section-certificates__container section-container">
        <h2 className="section-title">{t('certificates.title')}</h2>

        <div className="section-certificates__list">
          {certificates.map((entry) => {
            const title = lang === 'th' ? entry.nameTh : entry.name;
            const previewUrl = getPreviewUrl(entry);
            const isPdf = entry.credentialUrl && isPdfUrl(entry.credentialUrl);

            return (
              <article
                key={`${entry.name}-${entry.date}`}
                className={`section-certificates__item${
                  previewUrl || isPdf ? ' section-certificates__item--with-preview' : ''
                }`}
              >
                {previewUrl && entry.credentialUrl && (
                  <a
                    href={entry.credentialUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="section-certificates__preview"
                    aria-label={`${t('certificates.viewCredential')}: ${title}`}
                  >
                    <img
                      src={previewUrl}
                      alt={title}
                      className="section-certificates__preview-image"
                      loading="lazy"
                    />
                  </a>
                )}

                {!previewUrl && isPdf && entry.credentialUrl && (
                  <a
                    href={entry.credentialUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="section-certificates__preview section-certificates__preview--pdf"
                    aria-label={`${t('certificates.viewCredential')}: ${title}`}
                  >
                    <FontAwesomeIcon icon={faFilePdf} className="section-certificates__pdf-icon" />
                    <span>{t('certificates.viewCredential')}</span>
                  </a>
                )}

                <div className="section-certificates__body">
                  <span className="section-certificates__date">{entry.date}</span>
                  <h3 className="section-certificates__name">{title}</h3>
                  <p className="section-certificates__issuer">
                    {lang === 'th' ? entry.issuerTh : entry.issuer}
                  </p>
                  {entry.credentialId && (
                    <p className="section-certificates__credential-id">
                      {t('certificates.credentialId')}: {entry.credentialId}
                    </p>
                  )}
                  {entry.credentialUrl && previewUrl && (
                    <a
                      href={entry.credentialUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="section-certificates__link"
                    >
                      <FontAwesomeIcon icon={faExternalLinkAlt} />
                      <span>{t('certificates.viewCredential')}</span>
                    </a>
                  )}
                </div>
              </article>
            );
          })}
        </div>
      </Container>
    </section>
  );
};

export default SectionCertificates;
